<style scoped>
@media only screen and (max-width: 768px) {
  .nav-links{
    display: none;
  }


}
 
.app-header {
  background-color: var(--bg);
  border-bottom: 1px solid var(--text);
}

.brand {
  font-size: 23px;
  font-weight: 900!important;
  /*border: 3px solid var(--accent-primary);*/
  border: 3px solid rgb(var(--v-theme-on-surface)) ;
  padding: 0px 15px!important;
    color: rgb(var(--v-theme-on-surface))  ;
  text-decoration: none;
  margin-right: 12px;
}

.divider {
  margin: 0 12px;
  color: var(--text);
}

.nav-links a {
  margin-right: 20px;
  font-size: 15px;
    color: rgb(var(--v-theme-on-surface));
  text-decoration: none;
  font-weight: 500!important;
}

.nav-links a:hover {
  text-decoration: underline;
}

.actions {
  gap: 8px;
}

.write-btn {
  font-weight: 500;
  text-transform: none;
}


 

</style>

<template>
 
    <v-row justify="center"  >
        <v-col cols="12" md="1" > </v-col>
        <v-col cols="12" md="10"  >
        <v-container style="margin:auto" class="d-flex align-center justify-space-between pa-0 ma-0 mt-10">

        <!-- Left: Brand + Nav -->
        <div class="d-flex align-center">
            <router-link to="/" class="brand">
            LWYR
            </router-link>

            <span class="divider">|</span>

            <nav class="nav-links">
            <router-link to="/daily">Daily Brief</router-link>  
            <router-link to="/trending">Trending</router-link>
            
            <router-link to="/search">Search</router-link>
            <router-link to="/favorites">Favorites</router-link>
            </nav>
        </div>

        <!-- Right: Actions -->
        <div class="d-flex align-center actions">
            <!--
            <v-btn
            variant="text"
            class="write-btn"
            prepend-icon="mdi-bell-outlin"
            to="/test"
            style="color:rgb(var(--v-theme-on-surface)); font-weight:600!important;"
            >
            test
            </v-btn>
            -->
            <v-tooltip text="Coming soon">
              <template #activator="{ props }">
                <v-btn icon variant="text" v-bind="props">
                <v-badge dot color="red">
                    <v-icon>mdi-bell-outline</v-icon>
                </v-badge>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip text="Coming soon">
              <template #activator="{ props }">
                <v-avatar v-bind="props">
                  <v-icon icon="mdi-account-circle"></v-icon>
                </v-avatar>
              </template>
            </v-tooltip>
            <!--
            <v-btn icon variant="text">
            <v-badge dot color="red">
                <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
            </v-btn>

            <v-avatar  >
              <v-icon icon="mdi-account-circle"></v-icon>
            </v-avatar>
            -->
        </div>

        </v-container>  
        </v-col>
        <v-col cols="12" md="1"> </v-col>
    </v-row>
 
</template>

